import { WithStyles, withStyles } from '@mui/styles';

import { FirmAccountDetails } from './firmAccountDetails';
import { muiStyles } from './styles';

export interface FirmAccountDetailsProps extends WithStyles<typeof muiStyles> {
    match: any;
}

export default withStyles(muiStyles)(FirmAccountDetails);